import { API_LOAN_DOWNLOAD_LOAN_ESTIMATE_PAGE1, API_LOAN_GET_LOAN_ESTIMATE, API_LOAN_GET_LOAN_ESTIMATE_BY_KEY } from 'config'
import Api from 'services/api'

export const getLoanEstimate = () => {
  return Api.get(API_LOAN_GET_LOAN_ESTIMATE)
}

export const updateLoanEstimate = (key: string, value: any) => {
  return Api.put(API_LOAN_GET_LOAN_ESTIMATE_BY_KEY, { value }, { key })
}

export const getLoanEstimateLogs = (key: string) => {
  return Api.get(API_LOAN_GET_LOAN_ESTIMATE_BY_KEY, { key }, { key: 'log' })
}

export const downloadLoanEstimatePage1 = () => {
  return Api.get(API_LOAN_DOWNLOAD_LOAN_ESTIMATE_PAGE1, {}, {}, { responseType: 'blob', timeout: 150000 })
}
